import React, { useEffect, useState } from 'react';
import Sidebar from '../components/AdminSidebar';
import '../styles/AdminReports.css'; 
import ReportModal from '../components/ReportModal';
import { Download, FileText, Plus, Trash2 } from 'lucide-react';

export default function AdminRaport() {
    // State to hold loading state
    const [loading, setLoading] = useState(true);
    // State to hold analytics data
    const [analyticsData, setAnalyticsData] = useState({
        totalReports: 0,
        thisMonth: 0,
        avgDownloads: 0,
        mostPopular: 'Brak danych',
    });
    // State to show modal
    const [isModalOpen, setModalOpen] = useState(false);
    // State to hold list files
    const [files, setFiles] = useState([]);

    // Function to fetch analytics
    const fetchAnalytics = async () => {
        try {
            const statsResponse = await fetch(`${process.env.REACT_APP_API_URL}/reports/stats`);
            if (statsResponse.ok) {
                const statsData = await statsResponse.json();
                setAnalyticsData(statsData);
            }
        } catch (error) {
            console.error('Błąd podczas pobierania danych analitycznych:', error);
        }
    };

    // Function to fetch files
    const fetchFiles = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/reports/list`);
            const data = await response.json();
            setFiles(data);
        } catch (error) {
            console.error('Error fetching report list:', error);
        } finally {
            setLoading(false);
        }
    };

    // Function to handle report deletion
    const handleDeleteReport = async (fileName) => {
        if (!window.confirm(`Czy na pewno chcesz usunąć raport "${fileName}"?`)) {
            return;
        }

        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`${process.env.REACT_APP_API_URL}/reports/${fileName}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (response.ok) {
                // Refresh the list and statistics
                fetchFiles();
                fetchAnalytics();
            } else {
                const error = await response.json();
                alert(`Błąd podczas usuwania raportu: ${error.error || 'Nieznany błąd'}`);
            }
        } catch (error) {
            console.error('Error deleting report:', error);
            alert('Wystąpił błąd podczas usuwania raportu. Spróbuj ponownie.');
        }
    };

    // Function to open and close the modal
    const openModal = () => setModalOpen(true);
    // Function to close the modal
    const closeModal = () => {
        setModalOpen(false);
        // Refresh the reports list after closing modal (in case a new report was generated)
        fetchFiles();
        fetchAnalytics();
    };

    useEffect(() => {
        fetchAnalytics();
        fetchFiles();
    }, []); 

    if (loading) return <p>Ładowanie danych...</p>;
    
    return (
        <div className='admin-dashboard'>
            {/* Sidebar */}
            <Sidebar />
            {/* Main content */}
            <div className='main-content'>
                <div className='header'>
                    <h1 className='header-title'>Raporty</h1>
                </div>
                 <div className='dashboard'>
                    <h2 className='page-title'>Panel Raportów</h2>
                    <p className='page-subtitle'>Generowanie i zarządzanie raportami analitycznymi</p>
                    { /* Analytics Cards */}
                    <div className="stats-grid-reports">
                        <div className="stat-card-reports">
                            <div className="stat-number stat-number-dark">{analyticsData.totalReports}</div>
                            <div className="stat-label">Łącznie raportów</div>
                        </div>
                        <div className="stat-card-reports">
                            <div className="stat-number stat-number-green">{analyticsData.thisMonth}</div>
                            <div className="stat-label">W tym miesiącu</div>
                        </div>
                        <div className="stat-card-reports">
                            <div className="stat-number stat-number-blue">{analyticsData.avgDownloads}</div>
                            <div className="stat-label">Średnio pobrań</div>
                        </div>
                        <div className="stat-card-reports">
                            <div className="stat-number-purple">{analyticsData.mostPopular}</div>
                            <div className="stat-label">Najpopularniejszy</div>
                        </div>
                    </div>
                    <div className='report-main-grid'>
                        <div className='report-card'>
                            <div className='report-card-header'>
                                <div className='report-card-title-icon'>
                                    <FileText size={20} color='#16a34a' />
                                    <h3 className='report-card-title'>Ostatnie raporty</h3>
                                </div>
                                <button 
                                    className='report-button report-button-primary'
                                    onClick={openModal}
                                >
                                    <Plus size={20} />
                                    Nowy raport
                                </button>
                            </div>
                            {/* Report Modal */}
                            <ReportModal 
                                isOpen={isModalOpen}
                                onClose={closeModal}
                            />
                            {/* Report list */}
                            <div className='report-list'>
                                <table className='report-table'>
                                    <thead>
                                        <tr>
                                            <th className='report-th'>Nazwa raportu</th>
                                            <th className='report-th'>Kategoria</th>
                                            <th className='report-th'>Format</th>
                                            <th className='report-th'>Utworzył</th>
                                            <th className='report-th'>Data</th>
                                            <th className='report-th'>Status</th>
                                            <th className='report-th'>Akcje</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {files.length === 0 ? (
                                            <tr>
                                                <td colSpan="7" className='report-td' style={{ textAlign: 'center', color: '#64748b' }}>
                                                    Brak raportów
                                                </td>
                                            </tr>
                                        ) : (
                                            files.map((file, idx) => (
                                                <tr key={idx}>
                                                    <td className='report-td'>
                                                        <div className='row-div'>
                                                            <div className='icon-row'></div>
                                                            <div>
                                                                <div className='row-raport-name'>{file.name}</div>
                                                                <div className='row-description'>
                                                                    {file.size} MB
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className='report-td'>{file.category || '-'}</td>
                                                    <td className='report-td'>{file.type || '-'}</td>
                                                    <td className='report-td'>{file.createdBy || '-'}</td>
                                                    <td className='report-td'>
                                                        {file.createdAt ? new Date(file.createdAt).toLocaleDateString('pl-PL') : '-'}
                                                    </td>
                                                    <td className='report-td'>
                                                        {file.downloadCount > 0 ? `${file.downloadCount} pobrań` : 'Brak pobrań'}
                                                    </td>
                                                    <td>
                                                        <div className='report-actions'>
                                                            <a 
                                                                className='report-download-button'
                                                                target='_blank'
                                                                rel="noopener noreferrer"
                                                                href={`${process.env.REACT_APP_API_URL}/reports/download/${file.name}`}
                                                            >
                                                                <Download size={16} color='#64748b'/>
                                                            </a>
                                                            <button
                                                                className='report-delete-button'
                                                                onClick={() => handleDeleteReport(file.name)}
                                                                title="Usuń raport"
                                                            >
                                                                <Trash2 size={16} color='#dc2626'/>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}